export default "__VITE_ASSET__CdKqRI$s__"